import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as crmRoutes } from './crm/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as groupsRoutes } from './groups/routes';
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: () => import('./Dashboard.vue'),
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...crmRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...groupsRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: () => import('./onboarding/Index.vue'),
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/inbox-setup'),
      name: 'onboarding_inbox_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: () => import('./onboarding/InboxSetup.vue'),
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/billing'),
      name: 'onboarding_billing_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: () => import('./onboarding/BillingSetup.vue'),
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: () => import('./suspended/Index.vue'),
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: () => import('./noAccounts/Index.vue'),
    },
  ],
};
